import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApplicationRoutingModule } from './application-routing.module';
import { MaterializeModule } from 'angular2-materialize';
import { TextMaskModule } from 'angular2-text-mask';
import { LaddaModule } from 'angular2-ladda';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { ZestCommonModule } from '../common/common.module';

import { LoanAgreementComponent } from './loan-agreement/loan-agreement.component';
import { DownPaymentComponent } from './down-payment/down-payment.component';
import { CardComponent } from './card/card.component';
import { DownPaymentFailComponent } from './down-payment-fail/down-payment-fail.component';
import { JuspayComponent } from './juspay/juspay.component';
import { CounterOfferComponent } from './counter-offer/counter-offer.component';

import { AppGuardService } from './app-guard.service';
import { DownpaymentService } from './down-payment/down-payment.service';
import { LoanAgreementService } from './loan-agreement/loan-agreement.service';
import { JuspayService } from './juspay/juspay.service';
import { GenericErrorComponent } from '../info-pages/generic-error/generic-error.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ApplicationRoutingModule,
    MaterializeModule,
    TextMaskModule,
    DeviceDetectorModule.forRoot(),
    LaddaModule.forRoot({
      style: 'contract',
      spinnerSize: 50,
      spinnerColor: '#1eba68',
      spinnerLines: 100,
    }),
    ZestCommonModule
  ],
  declarations: [
    LoanAgreementComponent,
    DownPaymentComponent,
    CardComponent,
    DownPaymentFailComponent,
    JuspayComponent,
    CounterOfferComponent,
    GenericErrorComponent
  ],
  exports: [
    CardComponent
  ],
  providers: [
    DownpaymentService,
    LoanAgreementService,
    AppGuardService,
    JuspayService
  ]
})
export class ApplicationModule { }
